module.exports = {"userInfoText":"帳戶資訊","logoutText":"登出","userLang":"繁體中文","language":"語言","group":"群組","languageItem":{"en-US":"English","zh-TW":"繁體中文","zh-CN":"簡体中文"},"en-US":"English","zh-TW":"繁體中文","zh-CN":"簡体中文","themeText":"主題","Mobile":{"userLang":"繁"},"selectPlaceholder":"請選擇","selectTimePlaceholder":"選擇時間","selectNotFoundText":"無相符數據","tableNoDataText":"沒有資料","tableNoFilteredDataText":"沒有篩選結果"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/main.json
// module id = 76+z
// module chunks = 3